import { Control, useFieldArray } from 'react-hook-form';

import { useFormContext } from 'core/states';

import { IPricingProfileAccessForm } from './types';

export const useAccessFieldArray = () => {
  const { control } = useFormContext();

  const customersFieldArray = useFieldArray<IPricingProfileAccessForm, 'customers'>({
    control: control as unknown as Control<IPricingProfileAccessForm>,
    name: 'customers',
  });

  const usersFieldArray = useFieldArray<IPricingProfileAccessForm, 'users'>({
    control: control as unknown as Control<IPricingProfileAccessForm>,
    name: 'users',
  });

  const locationsFieldArray = useFieldArray<IPricingProfileAccessForm, 'locations'>({
    control: control as unknown as Control<IPricingProfileAccessForm>,
    name: 'locations',
  });

  const regionsFieldArray = useFieldArray<IPricingProfileAccessForm, 'regions'>({
    control: control as unknown as Control<IPricingProfileAccessForm>,
    name: 'regions',
  });

  return {
    customers: customersFieldArray,
    users: usersFieldArray,
    locations: locationsFieldArray,
    regions: regionsFieldArray,
  };
};
